import { render } from "./Footer.vue?vue&type=template&id=131ae8c8&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=131ae8c8&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Carla\\Projects\\Personal\\my-personal-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-131ae8c8"]])

export default __exports__